// extracted by mini-css-extract-plugin
module.exports = {"signature":"Signature_signature__iG6GO","signature__pad":"Signature_signature__pad__2icF6"};